
angular.module('ui2.0Directives')
    .directive('shareFilter', ['$rootScope', '$http', '$location','$q', function ($rootScope, http, $location,$q){
        return {
            restrict: "E",
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/shareFilter.html"),
            link: function ($scope, element, attrs) {
                $scope.userOptions = [];
                $scope.users = [];
                $scope.url = "/options/3?pageType=1";
                $scope.openShareFilterBool=false;
                $scope.openShareFilterBox=function (e,view,boolShareBox) {
                    $scope.$broadcast('clearSearchVal');
                    if(boolShareBox || $scope.openShareFilterBool && $(".icon-Share_1:hover").length == 0){
                        $scope.openShareFilterBool = !$scope.openShareFilterBool;
                    }
                    if($scope.openShareFilterBool && window.conditionCheck.isSearchResultPage()) {
                        const element = document.getElementsByClassName("viewSaveButton")[0];
                        const viewportOffset = element.getBoundingClientRect();
                        const leftOffsetModRibbon = viewportOffset.left;
                        const topOffsetModRibbon = viewportOffset.top;
                        const heightModRibbon = viewportOffset.height;
                        $(".share_filter_container").css({
                            "position": "fixed",
                            "left": leftOffsetModRibbon + "px",
                            "top": topOffsetModRibbon + heightModRibbon + 3 + "px"
                        });
                    }
                    $scope.viewDd = false;
                    if($scope.users || $scope.msgTxt){
                        $scope.users = [];
                        $scope.msgTxt = '';
                    }
                    $scope.viewToShare = view;
                    if( window.location.href.indexOf("preferredViewId")== -1){
                        if(window.conditionCheck.isSearchResultPage()) {
                            $scope.viewToShare && ($scope.currentViewUrl = `${window.location.origin}${window.location.pathname}#/listRender/${listId}?preferredViewId=${$scope.viewToShare.id}`);
                        } else if(window.location.href.indexOf("?")!= -1){
                            $scope.viewToShare && ($scope.currentViewUrl = window.location.href + "&preferredViewId=" +  $scope.viewToShare.id) ;
                        } else{
                            $scope.viewToShare && ($scope.currentViewUrl = window.location.href + "?preferredViewId=" +  $scope.viewToShare.id) ;
                        }
                    }
                    else{
                        var newUrl = window.location.href;
                        var index = newUrl.indexOf('?preferredViewId');
                        if(index != -1) {
                            newUrl = newUrl.slice(0,index)
                        }
                        $scope.viewToShare && ($scope.currentViewUrl = SirionUtils.updateQueryStringParameter(newUrl,"preferredViewId",$scope.viewToShare.id));
                    }

                }
                $scope.closeShareFilterBox = function(){
                    $scope.openShareFilterBool = false;
                    $scope.$broadcast('clearSearchVal');
                }
                $scope.viewToShare = {};

                $scope.copyUrlToClip = function($data){
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($data).select();
                    document.execCommand("copy");
                    $temp.remove();
                }

                $scope.isFilterUrlCopied=false;

                $scope.copyFilterUrl=function () {
                    $scope.copyUrlToClip(window.SirionUtils.removeURLParameter($scope.currentViewUrl,"uuid"));
                    $scope.isFilterUrlCopied=!$scope.isFilterUrlCopied;
                    setTimeout(function() {
                        $scope.isFilterUrlCopied=false;
                    },2000)
                }
                $scope.msgTxt;
                $scope.shareView = function(){
                    var postData = {
                        message: $scope.msgTxt,
                        viewName: $scope.viewToShare.name,
                        url: $scope.currentViewUrl,
                        data: $scope.users
                    }
                    $scope.usersFlag = true;
                    if($scope.users.length<1){
                        $scope.usersFlag = true;
                    }
                    else{
                        http.post('/listview/share',postData)
                            .then(function(response){
                                console.log(response)
                            })
                        
                        
                        let appendUsersInToastMsg = $scope.users.length;
                        let toastMsg = intl_msg[31660] || "View %s has been shared with %s users";
                        
                        if($scope.users.length === 1){
                            appendUsersInToastMsg = $scope.users[0].name;
                            toastMsg = intl_msg[31659] || "View %s has been shared with %s";
                        }

                        const displayToastMessage = window.SirionUtils.formatMessage(toastMsg, [$scope.viewToShare.name, appendUsersInToastMsg]);
                        Toaster.create(displayToastMessage);

                        $scope.closeShareFilterBox();
                        $scope.usersFlag = false;
                    }
                }
                 var openShareFilterBox = $scope.$on('open share view',function(e,data){
                    $scope.openShareFilterBox(data.event,data.view,data.bool);
                })

                $scope.$on('$destroy', function() {
                    openShareFilterBox();
                });

        }}
    }]);